import { ArrayDataSource } from './BaseDataSources';
import { IReviewType } from '../Interfaces';

export class ReviewTypeSource extends ArrayDataSource<IReviewType> {
  public constructor(importProcessId: number | null = null, onlyImportProcess: boolean | null = null, isException: boolean | null = null) {
    super('/datasource/reviewtypes', { importProcessId, onlyImportProcess, isException });
  }
}